import React from "react";

const LegalTableOfContents = ({ items, ariaLabel, className = "mt-7" }) => (
  <div className={`${className} border-t border-white/10 pt-6 lg:min-h-0 lg:flex-1`}>
    <div className="flex items-center justify-between gap-4">
      <h2 className="text-sm font-extrabold uppercase tracking-[0.14em] text-white">
        Table of contents
      </h2>
      <span className="shrink-0 rounded-full bg-white/10 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-slate-300">
        {items.length} sections
      </span>
    </div>

    <nav className="mt-4" aria-label={ariaLabel}>
      <ol className="grid gap-1.5 sm:grid-cols-2 lg:grid-cols-1">
        {items.map((item, index) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className="group flex min-h-11 items-center gap-3 rounded-xl border border-transparent px-2.5 py-2 text-sm font-semibold leading-5 text-slate-300 transition hover:border-white/10 hover:bg-white/10 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FFDB16]"
            >
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-white/10 text-[11px] font-extrabold text-[#FFDB16] transition group-hover:bg-[#FFDB16] group-hover:text-slate-950">
                {String(index + 1).padStart(2, "0")}
              </span>
              <span>{item.label}</span>
            </a>
          </li>
        ))}
      </ol>
    </nav>
  </div>
);

export default LegalTableOfContents;
